import React from 'react';
import { Grid, TextField, InputAdornment, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Profile } from '../types';
import EuroIcon from '@mui/icons-material/Euro';

interface PersonalInfoFormProps {
  profile: Profile;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PersonalInfoForm: React.FC<PersonalInfoFormProps> = ({ profile, handleChange }) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.firstname')}
          name="firstname"
          value={profile.firstname}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.surname')}
          name="surname"
          value={profile.surname}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.email')}
          name="email"
          type="email"
          value={profile.email}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.phone')}
          name="phoneNumber"
          value={profile.phoneNumber}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.birthdate')}
          name="birthdate"
          type="date"
          value={profile.birthdate}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.birthplace')}
          name="birthplace"
          value={profile.birthplace}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.income')}
          name="income"
          type="number"
          value={profile.income}
          onChange={handleChange}
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EuroIcon sx={{ marginLeft: '0.5rem', fontSize: '1rem', color: '#777' }} />
              </InputAdornment>
            )
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              padding: 0,
              '&:hover fieldset': {
                borderColor: 'primary.main',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'primary.main',
              }
            }
          }}
        />
      </Grid>
    </>
  );
};

export default PersonalInfoForm; 